const headerAnimations = ($) => {

  // category links toggler
  $('.site-header__fast-links-switcher').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('active');
  });

  // mobile menu toggler
  $('.mobile-header__hamburger').on('click', function () {
    $(this).toggleClass('is-active');
  });

  //mobile menu-items toggling
  $('.menu-item-has-children').on('click', function (e) {
    e.stopPropagation();

    const $menuItem = $(this);
    const $subMenu = $menuItem.children('.sub-menu');

    if (!$menuItem.hasClass('active')) {
      $subMenu.css('height', 'auto');
      $menuItem.addClass('active');
    } else {
      $subMenu.css('height', 0);
      $menuItem.removeClass('active');
    }
  });

  // Calculate height of the mobile nav-menu according to viewport height
  function setMenuHeight () {
    const viewportHeight = window.innerHeight;
    const logoHeight = $('.mobile-header__logo').innerHeight();
    const menuHeight = $('.mobile-header__nav-container').innerHeight();

    $('.mobile-header__navigation').css('height', `${viewportHeight - logoHeight - menuHeight}px`);
  }
  // setMenuHeight();
  // $(window).on('resize', function () {setMenuHeight();});

  //CHANGE HEADER HEIGHT
  const changeHeaderOnScroll = (header) => {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0
    };

    const changeHeaderClass = (className, entry) => {
      if (!entry.isIntersecting) {
        header.classList.add(className);
      } else {
        header.classList.remove(className);
      }
      // window.setTimeout(setMenuHeight, 400);//change height of the mobile menu
    };

    const classSwitcher = (entries, observer) => {
      entries.map(entry => {
        // header change point intersection
        if (entry.target.className === 'header-minimizer') changeHeaderClass('shrink', entry);
      });
    };

    const headerChangePoint = document.getElementsByClassName('header-minimizer')[0];

    const observer = new IntersectionObserver(classSwitcher, options);
    observer.observe(headerChangePoint);
  };

  const headers = [...document.getElementsByClassName('wa-header')].map(changeHeaderOnScroll);

}

export default headerAnimations;
